export default __webpack_public_path__ + "static/media/ksivalue_medium@2x.1af3ba1b.jpg";